import face from "../assets/Images/Face-and-Object-detection.png";
import question from "../assets/Images/Question-Similarity.png";
import test from "../assets/Images/Test-Forensic.png";
import document from "../assets/Images/Document-chat.png";
import speechLogo from "../assets/Images/speech-evaluation.png";
import keystroke from "../assets/Images/Keystroke-Analysis.png";
import voice from "../assets/Images/Voice-Analysis.png";
import aiContent from "../assets/Images/AI-Content-Generator.png";
import smartInsights from "../assets/Images/Smart-Insights.png";
import autoEssay from "../assets/Images/Auto-Essay-Evaluation.png";
import item from "../assets/Images/Item-Metadata-Generator.png";

export const snackbarColor = {
  success: "success",
  error: "error",
  warning: "warning",
  info: "info",
};

export const assessmentConfig = {
  AssessmentCountLimit: 5,
  ReadingAudioDurationLimitInSec: 5,
  SpeakingAudioDurationLimitInSec: 20,
  FileSizeLimitInMB: 3,
  BackgroundServiceDelayInSec: 10,
};

export const tabKeyword = {
  Reading: "Reading",
  Speaking: "Speaking",
};

export const errorTypes = {
  None: "None",
  Omission: "Omission",
  Insertion: "Insertion",
  Mispronunciation: "Mispronunciation",
  Monotone: "Monotone",
  UnexpextedBreak: "Unexpexted Break",
  MissingBreak: "Missing Break",
};
export const assessmentStatus = {
  pending: "Pending",
  processing: "Processing",
  completed: "Completed",
  error: "Error",
};

export const resultRefreshTime = {
  twoSeconds: 2000,
  fiveSeconds: 5000,
};

export const colors = {
  primary: "bg-[#265073]",
  // primary: 'bg-[#27374D]',
  primaryText: "text-[#526D82]",
  primaryBorder: "border-[#526D82]",
  primaryButton: "bg-[#27374D]",
  primaryPure: "#2B4865",
  primayIcon: "text-[#176ba6]",
  tableText: "text-[13px] text-[#505252] py-2",
};

export const redirectOptions = [
  {
    id: 1,
    source: "face",
    name: "Face and Object Detection",
    redirectUrl: "https://ai.excelsoftcorp.com/ai-apps/face-object-detection/",
    image: face,
  },
  {
    id: 2,
    source: "question",
    name: "Question Similarity",
    redirectUrl: "https://ai.excelsoftcorp.com/ai-apps/question-similarity/",
    image: question,
  },
  {
    id: 3,
    source: "document",
    name: "Document Chat",
    redirectUrl: "https://ai.excelsoftcorp.com/ai-apps/document_chat_mobydick/",
    image: document,
  },
  {
    id: 4,
    source: "test",
    name: "Test Forensic",
    redirectUrl: "https://ai.excelsoftcorp.com/ai-apps/test-dataforensics/",
    image: test,
  },
  {
    id: 5,
    source: "speech",
    name: "Speech Evaluation",
    redirectUrl: "",
    image: speechLogo,
  },
  {
    id: 6,
    source: "keystroke",
    name: "Keystroke Analysis",
    redirectUrl: "",
    image: keystroke,
  },
  {
    id: 7,
    source: "voice",
    name: "Voice Analysis",
    redirectUrl: "",
    image: voice,
  },
  {
    id: 8,
    source: "content",
    name: "AI Content Generator",
    redirectUrl: "",
    image: aiContent,
  },
  {
    id: 9,
    source: "smart",
    name: "Smart Insights",
    redirectUrl: "",
    image: smartInsights,
  },
  {
    id: 10,
    source: "essay",
    name: "Auto Essay Evaluation",
    redirectUrl: "",
    image: autoEssay,
  },
  {
    id: 11,
    source: "item",
    name: "Item Metadata Generator",
    redirectUrl: "https://ai.excelsoftcorp.com/ai-apps/meta-data-custom/",
    image: item,
  },
];
